/**
 * Health engine operator cards for #/readiness?tab=health (BEFORE-102).
 * Status cards + alerts with severity/owner/remediation — not raw JSON dumps.
 */

export function severityBadgeClass(sev) {
  const s = String(sev || "").toLowerCase();
  if (s === "critical" || s === "error" || s === "high") return "badge offline";
  if (s === "warn" || s === "warning" || s === "medium") return "badge warn";
  if (s === "ok" || s === "healthy" || s === "low" || s === "info") return "badge ok";
  return "badge";
}

export function buildHealthStatusCardsHtml(status) {
  const pack = status || {};
  const deviceCount = pack.device_count != null ? pack.device_count : (Array.isArray(pack.devices) ? pack.devices.length : 0);
  const coverage = pack.metric_coverage != null ? pack.metric_coverage : pack.coverage;
  const thresholds = pack.thresholds && typeof pack.thresholds === "object" ? Object.keys(pack.thresholds).length : 0;
  const cards = [
    { k: "Devices observed", v: String(deviceCount), hint: "Account devices with health metrics" },
    { k: "Metric coverage", v: coverage != null ? String(coverage) : "—", hint: "Share of expected metrics present" },
    { k: "Thresholds", v: String(thresholds), hint: "Configured alert thresholds" },
    { k: "Account", v: String(pack.tenant_id || "—"), hint: "Account scope" },
  ];
  return `<div class="stats health-status-cards" style="margin:12px 0">${cards.map((c) => `
    <div class="stat glass-panel glass-panel--inset health-status-card" data-health-card="${escapeHtmlAttr(c.k)}">
      <span class="k">${escapeHtml(c.k)}</span>
      <strong class="v">${escapeHtml(c.v)}</strong>
      <span class="muted" style="font-size:11px">${escapeHtml(c.hint)}</span>
    </div>`).join("")}</div>`;
}

export function buildHealthAlertsTableHtml(alerts) {
  const items = Array.isArray(alerts && alerts.items) ? alerts.items : (Array.isArray(alerts) ? alerts : []);
  if (!items.length) {
    return `<table class="table" aria-label="Health alerts"><thead><tr>
      <th>Severity</th><th>Alert</th><th>Owner / device</th><th>Last check</th><th>Remediation</th>
    </tr></thead><tbody><tr><td colspan="5" class="muted">No health alerts.</td></tr></tbody></table>`;
  }
  const rows = items.map((a) => {
    const sev = a.severity || a.level || a.status || "—";
    const code = a.id || a.code || a.alert_id || a.metric || "—";
    const detail = a.message || a.detail || a.summary || "";
    const owner = a.device_id || a.owner || a.target || "—";
    const last = a.last_check_at || a.observed_at || a.at || a.ts || "—";
    const remHref = a.remediation || a.href || (a.device_id ? `#/devices/${encodeURIComponent(String(a.device_id))}` : "#/group/_all");
    const remLabel = a.remediation_label || "Open";
    return `<tr>
      <td><span class="${severityBadgeClass(sev)}">${escapeHtml(String(sev))}</span></td>
      <td><strong>${escapeHtml(String(code))}</strong><div class="muted" style="font-size:12px">${escapeHtml(String(detail))}</div></td>
      <td class="mono">${escapeHtml(String(owner))}</td>
      <td class="mono">${escapeHtml(String(last))}</td>
      <td>${String(remHref).startsWith("#/")
        ? `<button type="button" class="btn sm secondary btn-tap" data-cc-go="${escapeHtmlAttr(String(remHref).replace(/^#\/?/, ""))}">${escapeHtml(String(remLabel))}</button>`
        : "—"}</td>
    </tr>`;
  }).join("");
  return `<table class="table" aria-label="Health alerts"><thead><tr>
    <th>Severity</th><th>Alert</th><th>Owner / device</th><th>Last check</th><th>Remediation</th>
  </tr></thead><tbody>${rows}</tbody></table>`;
}

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function escapeHtmlAttr(s) {
  return escapeHtml(s).replace(/'/g, "&#39;");
}
